import { useMovementV2PageData } from 'src/app/pages/movementV2/pageContext';

type Result = ModelHookResult<{
	objective: string;
	description: string;
}>;

export function usePageMeta(): Result {
	const {
		data: {
			movement: { objective, description },
		},
	} = useMovementV2PageData();

	return {
		data: {
			objective,
			description,
		},
	};
}
